import './watch_video.css'
import introVideoImg1 from '../../assets/images/intro-video-img-1.jpg'
import introVideoPlayIcon from '../../assets/images/intro-video-play-icon.svg'

const WatchVideo = () => {
    return (
        <div className="video-watch-area pt-100">
            <div className="container">
                <div className="section-title">
                    <span className="top-title">Watch Video</span>
                    <h2>We Create the Perfect Shine</h2>
                </div>
                <div className="video-watch-item">
                    <img src={introVideoImg1} alt="images" />
                    <div className="video-play">
                        <a href="https://www.youtube.com/watch?v=-z-wtyXjFIg" target="_blank" className="popup-youtube">
                            <img src={introVideoPlayIcon} alt="images" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WatchVideo